import Vue from "vue";
import Router from "vue-router";
import Support from "../pages/Support.vue";
import Layout from "../components/Layout";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      component: Layout,
      redirect: "/spare",
      children: [
        {
          path: "spare",
          component: () => import("../pages/Spare.vue"),
          name: "spare",
          meta: { title: "践趣网络-应用分身" },
        },
        {
          path: "home",
          component: () => import("../pages/Home.vue"),
          name: "home",
          meta: { title: "践趣网络-远程控制" },
        },
        {
          path: "reports",
          component: () => import("../pages/Reports.vue"),
          name: "reports",
          meta: { title: "践趣网络-关于我们" },
        },
        {
          path: "down",
          component: () => import("../pages/Down.vue"),
          name: "down",
          meta: { title: "践趣网络-下载" },
        },
        {
          path: "vip",
          component: () => import("../pages/Vip.vue"),
          name: "vip",
          meta: { title: "践趣网络" },
        },
        {
          path: "login",
          component: () => import("../pages/Login.vue"),
          name: "login",
          meta: { title: "践趣网络-登录" },
        },
        {
          path: "register",
          component: () => import("../pages/Register.vue"),
          name: "register",
          meta: { title: "践趣网络-注册" },
        },
      ],
    },
    {
      path: "/support",
      name: "support",
      component: Support,
      meta: {
        title: "Contact us",
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "践趣网络";
  next();
});

export default router;
